module.exports = __webpack_public_path__ + "static/media/The Wedding Song.ea3f6965.jpg";